import styled from 'styled-components';
import { theme } from 'modules/tetrisTheme';
export const Container = styled.div `
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: ${theme.spacing.lg};
`;
